var _style, _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCognizant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 652 652",
    style: {
      enableBackground: "new 0 0 652 652"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0033A1;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M367.7,336.1l36-35.2h-35.5v-16.5h60.6v16.8l-36,35.1h36.7v16.6h-61.9V336.1z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 342.1,
    y: 261.8,
    className: "st0",
    width: 18.7,
    height: 17
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 341.8,
    y: 284.5,
    className: "st0",
    width: 18.7,
    height: 68.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115,318.5c0.1-19.6,16-35.4,35.6-35.3c19.6,0.1,35.4,16,35.3,35.6c-0.1,19.5-15.9,35.3-35.5,35.3 c-19.5,0-35.4-15.8-35.5-35.3C115,318.7,115,318.6,115,318.5z M167.8,318.5c0-9.7-7.7-17.8-17.2-17.8c-9.7,0-17.1,8.1-17.1,17.8 s7.4,17.8,17.1,17.8C160.1,336.3,167.8,328.2,167.8,318.5L167.8,318.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M270.6,284.3h18.6v7.7c4.4-5.6,11.1-9,18.9-9c16.2,0,25.9,10.4,25.9,28.1v41.8h-19v-39.3 c0-9.2-4.3-14.5-12.6-14.5c-7.1,0-13,4.9-13,16.4v37.4h-18.7V284.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M430.6,318.5c0-24.2,17.8-35.6,33.3-35.6c8.9,0,15.9,3.3,20.4,8.1v-6.7H503v68.5h-18.7v-7.7 c-4.5,5.3-11.8,9-20.7,9C449.1,354.1,430.6,342.6,430.6,318.5z M484.8,318.4c0-10.1-7.4-18.3-17.5-18.3c-10.4,0-18.3,7.8-18.3,18.3 s7.9,18.5,18.3,18.5C477.5,336.9,484.9,328.5,484.8,318.4L484.8,318.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M510.6,284.3h18.6v7.7c4.4-5.6,11.1-9,18.9-9c16.2,0,25.9,10.4,25.9,28.1v41.8h-19v-39.3 c0-9.2-4.2-14.5-12.6-14.5c-7.1,0-13,4.9-13,16.4v37.4h-18.7L510.6,284.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M367.7,352.7v-16.7l36-35.2h-35.5v-16.5h60.6v16.8l-36,35.1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95,317.9l-0.2,0.6c-5.2,10.9-14.7,17.2-26.1,17.2c-16.6,0-29.5-13.1-29.5-29.8c0-17.2,12.9-30,29.9-30 c11.1,0,19.4,5.2,25,15.4l0.3,0.6l16.7-10.7l-0.3-0.5c-8.7-14.8-24.2-23.6-41.7-23.6c-27.8,0-48.9,21-48.9,48.9 c0,28.3,20.5,48.8,48.8,48.8c18.2,0,34.3-10.1,43.1-27.1l0.3-0.5L95,317.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.7,318.5c0-24.2,17.8-35.6,33.3-35.6c8.9,0,15.9,3.7,20.4,8.8v-7.4h18.7v66.5c0,19.3-12.2,34.9-35.3,34.9 c-17.4,0-30.1-9-35.6-19.7l16.5-9.3c3.6,7.1,9.8,11.6,19,11.6c10.1,0,16.5-7.9,16.5-16.8v-6.4c-4.5,5.3-11.8,9-20.7,9 C209.1,354.1,190.7,342.6,190.7,318.5z M244.9,318.4c0-10.1-7.4-18.3-17.5-18.3c-10.4,0-18.3,7.8-18.3,18.3s7.9,18.5,18.3,18.5 C237.5,336.9,244.9,328.5,244.9,318.4L244.9,318.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M620.2,301.2v-16.8h-12.9v-22.6h-18.7v22.6h-11.7v16.8h11.6V323c0,22.3,7.1,29.7,28.9,29.7h2.7v-17.5 c-11.5,0-12.9-1.6-12.9-12.3v-21.7H620.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCognizant);
export default __webpack_public_path__ + "static/media/cognizant.6f1ffaf9e4e2c5e7334c1e5e19c330e3.svg";
export { ForwardRef as ReactComponent };